import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth/useAuth';
import { UploadsListTable } from '@/features/uploads/components/UploadsListTable';

export function UploadsListPage() {
  const { hasRole } = useAuth();
  const isAdmin = hasRole('admin');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Uploads</h1>
        <Button asChild>
          <Link to="/uploads/new">
            <Plus className="size-4" />
            New upload
          </Link>
        </Button>
      </div>
      <UploadsListTable isAdmin={isAdmin} />
    </div>
  );
}
